// extracted by mini-css-extract-plugin
export var container = "TwoColWithImage-module--container--64405";
export var description = "TwoColWithImage-module--description--da697";
export var descriptions = "TwoColWithImage-module--descriptions--879b0";